import Loading from "@/components/Loading";
import PasswordResetMailAddressForm from "@/components/Form/PasswordResetMailAddressForm.js";
import {
  useAccountSendPasswordResetTokenMutation,
  useRequireLogout,
  useRequireIdcLogin,
} from "@/hooks";
import routes from "@/lib/routes";
import processStyles from "@/styles/Process.module.scss";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";
import PasswordResetComplete from "@/components/PasswordResetComplete.js";
import PasswordRemindMetaTags from "@/components/MetaTags/PasswordRemindMetaTags";

export default function PasswordRemind() {
  const logoutResult = useRequireLogout();
  const idcLoginResult = useRequireIdcLogin();
  const router = useRouter();
  const [complete, setComplete] = useState(false);
  const [mailAddress, setMailAddress] = useState("");

  const [
    accountSendPasswordResetTokenMutation,
  ] = useAccountSendPasswordResetTokenMutation({
    onCompleted: ({ sendPasswordResetToken }) => {
      if (sendPasswordResetToken?.result) {
        setComplete(true);
        window.scrollTo(0, 0);
      }
    },
  });

  const handleBack = useCallback(() => {
    router.back();
  }, []);

  const handleSubmit = useCallback((data) => {
    setMailAddress(data.mailAddress);
    accountSendPasswordResetTokenMutation({
      variables: {
        mailAddress: data.mailAddress,
      },
    });
  }, []);

  const handleClick = useCallback(() => {
    router.push(routes.login);
  }, []);

  return (
    <>
      {(!logoutResult || !idcLoginResult) && <Loading fixed />}
      <PasswordRemindMetaTags type={complete ? "complete" : null} />
      <div className={processStyles.container}>
        <div className={processStyles.inner}>
          <h2
            className={`${processStyles.heading} ${processStyles.withoutSteps}`}
          >
            パスワードを忘れた方
          </h2>
          <div>
            {complete == false && (
              <PasswordResetMailAddressForm
                handleBack={handleBack}
                onSubmit={handleSubmit}
              />
            )}
            {complete == true && (
              <PasswordResetComplete
                handleClick={handleClick}
                mailAddress={mailAddress}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
PasswordRemind.layout = "NoHeaderLayout";
